webpackJsonp([2],{

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(805)(true);
// imports


// module
exports.push([module.i, ".cloud-managers-view{padding-top:71px;padding-bottom:40px}.cloud-managers-view .hanging-tooltip{font-size:14px;max-width:338px}.cloud-managers-view .component-container .component-contents .occm-row{height:80px;width:100%;margin-bottom:5px;position:relative;-webkit-box-shadow:0 5px 14px 0 rgba(0,0,0,.05);box-shadow:0 5px 14px 0 rgba(0,0,0,.05)}.cloud-managers-view .component-container .component-contents .occm-row.failed .occm-info .info,.cloud-managers-view .component-container .component-contents .occm-row.initializing .occm-info .info{width:400px}.cloud-managers-view .component-container .component-contents .occm-row.failed .occm-info,.cloud-managers-view .component-container .component-contents .occm-row.failed .occm-menu,.cloud-managers-view .component-container .component-contents .occm-row.initializing .occm-info,.cloud-managers-view .component-container .component-contents .occm-row.initializing .occm-menu{background-color:#f7f7f7}.cloud-managers-view .component-container .component-contents .occm-row .occm-info{display:block;float:left;width:calc(100% - 84px);height:100%;background-color:#fff}.cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .goto,.cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .info .text,.cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .info .title{color:#003eae!important}.cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .goto svg{fill:#003eae!important}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo{float:left;left:20px;position:relative;width:108px;height:100%}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo .isvg,.cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo img{position:absolute;top:14px;width:50px;height:50px}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo .isvg svg{width:100%;height:100%}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo .isvg.grey svg circle{fill:#868686}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .launching-text{width:212px;float:right}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .launching-text>span{line-height:80px;font-size:13px;margin-left:5px}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .failed-text{line-height:80px;font-size:13px;font-weight:bolder;color:#ca3652;float:right;width:212px}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .info{float:left;margin-top:18px;margin-right:45px;width:185px}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .info .title{font-weight:bolder;color:#636363;font-size:14px;margin-bottom:5px}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .info .text{color:#636363;font-size:14px;white-space:nowrap}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .goto{float:right;height:100%;font-weight:bolder;font-size:14px;color:#636363;line-height:80px;width:212px}.cloud-managers-view .component-container .component-contents .occm-row .occm-info .goto svg{width:23px;fill:#636363}.cloud-managers-view .component-container .component-contents .occm-row:hover .occm-info .goto{color:#636363}.cloud-managers-view .component-container .component-contents .occm-row:hover .occm-info .goto svg{fill:#636363}.cloud-managers-view .component-container .component-contents .occm-row.solitary .goto{color:#636363}.cloud-managers-view .component-container .component-contents .occm-row.solitary .goto svg{fill:#636363}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu{float:left;width:84px;height:100%;background-color:#fff;position:relative}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-children{position:absolute;opacity:0;-webkit-transition:all .4s cubic-bezier(.25,.8,.25,1);-o-transition:all .4s cubic-bezier(.25,.8,.25,1);transition:all .4s cubic-bezier(.25,.8,.25,1);-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transform-origin:top;-ms-transform-origin:top;transform-origin:top;z-index:1;top:55px;left:-65px;width:220px;background-color:#fff;-webkit-box-shadow:0 5px 14px 0 rgba(0,0,0,.05);box-shadow:0 5px 14px 0 rgba(0,0,0,.05);border:1px solid #d7d7d7;padding:11px 0 17px 13px}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child{display:block;color:#636363;background-color:transparent;border:none;outline:none;padding:10px}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:hover{color:#003eae}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:hover svg{fill:#003eae}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:disabled{color:#d7d7d7;cursor:not-allowed}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:disabled svg{fill:#d7d7d7}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:not(:last-child){margin-bottom:16px}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child .isvg{position:relative;display:inline-block;margin-right:3px}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child svg{fill:#636363}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .menu-children{opacity:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);-webkit-transition-delay:.3s;-o-transition-delay:.3s;transition-delay:.3s}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .dots .d1,.cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .dots .d2,.cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .dots .d3{background-color:#003eae}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots{top:calc(50% - 10px);position:absolute;width:44px;height:20px;left:20px;cursor:pointer}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d1,.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d2,.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d3{width:4px;height:4px;background-color:#636363;left:20px}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d1{position:absolute}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d2{position:absolute;top:8px}.cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d3{position:absolute;top:16px}", "", {"version":3,"sources":["/buildagent/work/b80dd0081a060cbb/ui/src/components/launch-pad/CloudManagersView.css"],"names":[],"mappings":"AAAA,qBACE,iBAAkB,AAClB,mBAAqB,CAAE,AACvB,sCACE,eAAgB,AAChB,eAAiB,CAAE,AACrB,wEACE,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,gDAAqD,AAC7C,uCAA6C,CAAE,AACvD,sMACE,WAAa,CAAE,AACjB,oXACE,wBAA0B,CAAE,AAC9B,mFACE,cAAe,AACf,WAAY,AACZ,wBAAyB,AACzB,YAAa,AACb,qBAAuB,CAAE,AAGzB,0SACE,uBAA0B,CAAE,AAC5B,mGACE,sBAAyB,CAAE,AAC/B,yFACE,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,YAAa,AACb,WAAa,CAAE,AACf,4LACE,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,WAAa,CAAE,AACjB,mGACE,WAAY,AACZ,WAAa,CAAE,AACjB,+GACE,YAAc,CAAE,AACpB,mGACE,YAAa,AACb,WAAa,CAAE,AACjB,wGACE,iBAAkB,AAClB,eAAgB,AAChB,eAAiB,CAAE,AACrB,gGACE,iBAAkB,AAClB,eAAgB,AAChB,mBAAoB,AACpB,cAAe,AACf,YAAa,AACb,WAAa,CAAE,AACjB,yFACE,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,WAAa,CAAE,AACf,gGACE,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,iBAAmB,CAAE,AACvB,+FACE,cAAe,AACf,eAAgB,AAChB,kBAAoB,CAAE,AAC1B,yFACE,YAAa,AACb,YAAa,AACb,mBAAoB,AACpB,eAAgB,AAChB,cAAe,AACf,iBAAkB,AAClB,WAAa,CAAE,AACf,6FACE,WAAY,AACZ,YAAc,CAAE,AACtB,+FACE,aAAe,CAAE,AACjB,mGACE,YAAc,CAAE,AACpB,uFACE,aAAe,CAAE,AACjB,2FACE,YAAc,CAAE,AACpB,mFACE,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,iBAAmB,CAAE,AACrB,kGACE,kBAAmB,AACnB,UAAW,AACX,sDAA8D,AAC9D,iDAAyD,AACzD,8CAAsD,AACtD,2BAA4B,AACxB,uBAAwB,AACpB,mBAAoB,AAC5B,6BAA8B,AAC1B,yBAA0B,AACtB,qBAAsB,AAC9B,UAAW,AACX,SAAU,AACV,WAAY,AACZ,YAAa,AACb,sBAAuB,AACvB,gDAAqD,AAC7C,wCAA6C,AACrD,yBAA0B,AAC1B,wBAA0B,CAAE,AAC9B,+FACE,cAAe,AACf,cAAe,AACf,6BAA8B,AAC9B,YAAa,AACb,aAAc,AACd,YAAc,CAAE,AAChB,qGACE,aAAe,CAAE,AACjB,yGACE,YAAc,CAAE,AACpB,wGACE,cAAe,AACf,kBAAoB,CAAE,AACtB,4GACE,YAAc,CAAE,AACpB,gHACE,kBAAoB,CAAE,AACxB,qGACE,kBAAmB,AACnB,qBAAsB,AACtB,gBAAkB,CAAE,AACtB,mGACE,YAAc,CAAE,AACpB,wGACE,UAAW,AACX,2BAA4B,AACxB,uBAAwB,AACpB,mBAAoB,AAC5B,6BAA+B,AAC1B,wBAA0B,AACvB,oBAAuB,CAAE,AACnC,ySACE,wBAA0B,CAAE,AAC9B,yFACE,qBAAsB,AACtB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,UAAW,AACX,cAAgB,CAAE,AAClB,uRACE,UAAW,AACX,WAAY,AACZ,yBAA0B,AAC1B,SAAW,CAAE,AACf,6FACE,iBAAmB,CAAE,AACvB,6FACE,kBAAmB,AACnB,OAAS,CAAE,AACb,6FACE,kBAAmB,AACnB,QAAU,CAAE","file":"CloudManagersView.css","sourcesContent":[".cloud-managers-view {\n  padding-top: 71px;\n  padding-bottom: 40px; }\n  .cloud-managers-view .hanging-tooltip {\n    font-size: 14px;\n    max-width: 338px; }\n  .cloud-managers-view .component-container .component-contents .occm-row {\n    height: 80px;\n    width: 100%;\n    margin-bottom: 5px;\n    position: relative;\n    -webkit-box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05);\n            box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05); }\n    .cloud-managers-view .component-container .component-contents .occm-row.failed .occm-info .info, .cloud-managers-view .component-container .component-contents .occm-row.initializing .occm-info .info {\n      width: 400px; }\n    .cloud-managers-view .component-container .component-contents .occm-row.failed .occm-info, .cloud-managers-view .component-container .component-contents .occm-row.failed .occm-menu, .cloud-managers-view .component-container .component-contents .occm-row.initializing .occm-info, .cloud-managers-view .component-container .component-contents .occm-row.initializing .occm-menu {\n      background-color: #f7f7f7; }\n    .cloud-managers-view .component-container .component-contents .occm-row .occm-info {\n      display: block;\n      float: left;\n      width: calc(100% - 84px);\n      height: 100%;\n      background-color: #fff; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .info .title, .cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .info .text {\n        color: #003eae !important; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .goto {\n        color: #003eae !important; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info:hover .goto svg {\n          fill: #003eae !important; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo {\n        float: left;\n        left: 20px;\n        position: relative;\n        width: 108px;\n        height: 100%; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo img, .cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo .isvg {\n          position: absolute;\n          top: 14px;\n          width: 50px;\n          height: 50px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo .isvg svg {\n          width: 100%;\n          height: 100%; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info .logo .isvg.grey svg circle {\n          fill: #868686; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info .launching-text {\n        width: 212px;\n        float: right; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info .launching-text > span {\n        line-height: 80px;\n        font-size: 13px;\n        margin-left: 5px; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info .failed-text {\n        line-height: 80px;\n        font-size: 13px;\n        font-weight: bolder;\n        color: #ca3652;\n        float: right;\n        width: 212px; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info .info {\n        float: left;\n        margin-top: 18px;\n        margin-right: 45px;\n        width: 185px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info .info .title {\n          font-weight: bolder;\n          color: #636363;\n          font-size: 14px;\n          margin-bottom: 5px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info .info .text {\n          color: #636363;\n          font-size: 14px;\n          white-space: nowrap; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-info .goto {\n        float: right;\n        height: 100%;\n        font-weight: bolder;\n        font-size: 14px;\n        color: #636363;\n        line-height: 80px;\n        width: 212px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-info .goto svg {\n          width: 23px;\n          fill: #636363; }\n    .cloud-managers-view .component-container .component-contents .occm-row:hover .occm-info .goto {\n      color: #636363; }\n      .cloud-managers-view .component-container .component-contents .occm-row:hover .occm-info .goto svg {\n        fill: #636363; }\n    .cloud-managers-view .component-container .component-contents .occm-row.solitary .goto {\n      color: #636363; }\n      .cloud-managers-view .component-container .component-contents .occm-row.solitary .goto svg {\n        fill: #636363; }\n    .cloud-managers-view .component-container .component-contents .occm-row .occm-menu {\n      float: left;\n      width: 84px;\n      height: 100%;\n      background-color: #fff;\n      position: relative; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-children {\n        position: absolute;\n        opacity: 0;\n        -webkit-transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n        -o-transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n        transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n        -webkit-transform: scale(0);\n            -ms-transform: scale(0);\n                transform: scale(0);\n        -webkit-transform-origin: top;\n            -ms-transform-origin: top;\n                transform-origin: top;\n        z-index: 1;\n        top: 55px;\n        left: -65px;\n        width: 220px;\n        background-color: #fff;\n        -webkit-box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05);\n                box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05);\n        border: solid 1px #d7d7d7;\n        padding: 11px 0 17px 13px; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child {\n        display: block;\n        color: #636363;\n        background-color: transparent;\n        border: none;\n        outline: none;\n        padding: 10px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:hover {\n          color: #003eae; }\n          .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:hover svg {\n            fill: #003eae; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:disabled {\n          color: #d7d7d7;\n          cursor: not-allowed; }\n          .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:disabled svg {\n            fill: #d7d7d7; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child:not(:last-child) {\n          margin-bottom: 16px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child .isvg {\n          position: relative;\n          display: inline-block;\n          margin-right: 3px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .menu-child svg {\n          fill: #636363; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .menu-children {\n        opacity: 1;\n        -webkit-transform: scale(1);\n            -ms-transform: scale(1);\n                transform: scale(1);\n        -webkit-transition-delay: 0.3s;\n             -o-transition-delay: 0.3s;\n                transition-delay: 0.3s; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .dots .d1, .cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .dots .d2, .cloud-managers-view .component-container .component-contents .occm-row .occm-menu:hover .dots .d3 {\n        background-color: #003eae; }\n      .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots {\n        top: calc(50% - 10px);\n        position: absolute;\n        width: 44px;\n        height: 20px;\n        left: 20px;\n        cursor: pointer; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d1, .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d2, .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d3 {\n          width: 4px;\n          height: 4px;\n          background-color: #636363;\n          left: 20px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d1 {\n          position: absolute; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d2 {\n          position: absolute;\n          top: 8px; }\n        .cloud-managers-view .component-container .component-contents .occm-row .occm-menu .dots .d3 {\n          position: absolute;\n          top: 16px; }\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(805)(true);
// imports


// module
exports.push([module.i, ".dialog.remove-occm-dialog .modal{width:600px;height:400px;top:calc(50% - 200px);left:calc(50% - 300px);padding-left:40px;padding-right:40px}.dialog.remove-occm-dialog .modal p{font-size:14px;color:#636363;margin:0 0 6px}.dialog.remove-occm-dialog .modal h3{font-size:18px;font-weight:400;color:#636363;margin:37px 0 4px;border-bottom:1px solid #d7d7d7}.dialog.remove-occm-dialog .modal .dialog-content{padding-top:25px}.dialog.remove-occm-dialog .modal .dialog-content.error .occm-row{margin-bottom:18px}.dialog.remove-occm-dialog .modal .dialog-content .occm-row{background-color:#f1f2f2;width:100%;height:100px;margin-bottom:40px;margin-top:14px}.dialog.remove-occm-dialog .modal .dialog-content .occm-row .logo{float:left;left:23px;position:relative;width:112px;height:100%}.dialog.remove-occm-dialog .modal .dialog-content .occm-row .logo .isvg{position:absolute;top:19px;width:60px;height:60px}.dialog.remove-occm-dialog .modal .dialog-content .occm-row .logo .isvg svg{height:100%;width:100%}.dialog.remove-occm-dialog .modal .dialog-content .occm-row .info{float:left;margin-top:27px;margin-right:20px}.dialog.remove-occm-dialog .modal .dialog-content .occm-row .info .title{font-weight:bolder;color:#636363;font-size:14px;margin-bottom:5px}.dialog.remove-occm-dialog .modal .dialog-content .occm-row .info .text{color:#636363;font-size:14px;white-space:nowrap}.dialog.remove-occm-dialog .modal .dialog-buttons{border-top:1px solid #d7d7d7;padding-top:18px}.dialog.remove-occm-dialog .modal .dialog-buttons button{margin-left:11px}", "", {"version":3,"sources":["/buildagent/work/b80dd0081a060cbb/ui/src/components/launch-pad/RemoveOccmDialog.css"],"names":[],"mappings":"AAAA,kCACE,YAAa,AACb,aAAc,AACd,sBAAuB,AACvB,uBAAwB,AACxB,kBAAmB,AACnB,kBAAoB,CAAE,AACtB,oCACE,eAAgB,AAChB,cAAe,AACf,cAAgB,CAAE,AACpB,qCACE,eAAgB,AAChB,gBAAoB,AACpB,cAAe,AACf,kBAAqB,AACrB,+BAAiC,CAAE,AACrC,kDACE,gBAAkB,CAAE,AACpB,kEACE,kBAAoB,CAAE,AACxB,4DACE,yBAA0B,AAC1B,WAAY,AACZ,aAAc,AACd,mBAAoB,AACpB,eAAiB,CAAE,AACnB,kEACE,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,YAAa,AACb,WAAa,CAAE,AACf,wEACE,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,WAAa,CAAE,AACf,4EACE,YAAa,AACb,UAAY,CAAE,AACpB,kEACE,WAAY,AACZ,gBAAiB,AACjB,iBAAmB,CAAE,AACrB,yEACE,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,iBAAmB,CAAE,AACvB,wEACE,cAAe,AACf,eAAgB,AAChB,kBAAoB,CAAE,AAC9B,kDACE,6BAA8B,AAC9B,gBAAkB,CAAE,AACpB,yDACE,gBAAkB,CAAE","file":"RemoveOccmDialog.css","sourcesContent":[".dialog.remove-occm-dialog .modal {\n  width: 600px;\n  height: 400px;\n  top: calc(50% - 200px);\n  left: calc(50% - 300px);\n  padding-left: 40px;\n  padding-right: 40px; }\n  .dialog.remove-occm-dialog .modal p {\n    font-size: 14px;\n    color: #636363;\n    margin: 0 0 6px; }\n  .dialog.remove-occm-dialog .modal h3 {\n    font-size: 18px;\n    font-weight: normal;\n    color: #636363;\n    margin: 37px 0 4px 0;\n    border-bottom: 1px solid #d7d7d7; }\n  .dialog.remove-occm-dialog .modal .dialog-content {\n    padding-top: 25px; }\n    .dialog.remove-occm-dialog .modal .dialog-content.error .occm-row {\n      margin-bottom: 18px; }\n    .dialog.remove-occm-dialog .modal .dialog-content .occm-row {\n      background-color: #f1f2f2;\n      width: 100%;\n      height: 100px;\n      margin-bottom: 40px;\n      margin-top: 14px; }\n      .dialog.remove-occm-dialog .modal .dialog-content .occm-row .logo {\n        float: left;\n        left: 23px;\n        position: relative;\n        width: 112px;\n        height: 100%; }\n        .dialog.remove-occm-dialog .modal .dialog-content .occm-row .logo .isvg {\n          position: absolute;\n          top: 19px;\n          width: 60px;\n          height: 60px; }\n          .dialog.remove-occm-dialog .modal .dialog-content .occm-row .logo .isvg svg {\n            height: 100%;\n            width: 100%; }\n      .dialog.remove-occm-dialog .modal .dialog-content .occm-row .info {\n        float: left;\n        margin-top: 27px;\n        margin-right: 20px; }\n        .dialog.remove-occm-dialog .modal .dialog-content .occm-row .info .title {\n          font-weight: bolder;\n          color: #636363;\n          font-size: 14px;\n          margin-bottom: 5px; }\n        .dialog.remove-occm-dialog .modal .dialog-content .occm-row .info .text {\n          color: #636363;\n          font-size: 14px;\n          white-space: nowrap; }\n  .dialog.remove-occm-dialog .modal .dialog-buttons {\n    border-top: 1px solid #d7d7d7;\n    padding-top: 18px; }\n    .dialog.remove-occm-dialog .modal .dialog-buttons button {\n      margin-left: 11px; }\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(805)(true);
// imports


// module
exports.push([module.i, ".dialog.update-occm-uris-dialog .modal{width:600px;height:440px;top:calc(50% - 220px);left:calc(50% - 300px);padding-left:40px;padding-right:40px}.dialog.update-occm-uris-dialog .modal .error-text{position:absolute;font-size:13px;font-weight:400}.dialog.update-occm-uris-dialog .modal h3{font-size:18px;font-weight:400;color:#636363;margin:37px 0 4px;border-bottom:1px solid #d7d7d7}.dialog.update-occm-uris-dialog .modal .dialog-content{padding-top:25px}.dialog.update-occm-uris-dialog .modal .dialog-content .uri-row:not(:last-child){margin-bottom:36px}.dialog.update-occm-uris-dialog .modal .dialog-content .mark-default{border:none;outline:none;background-color:transparent;color:#b7b7b7;font-size:13px;font-weight:bolder;float:right;margin-right:80px;position:relative}.dialog.update-occm-uris-dialog .modal .dialog-content .mark-default svg{position:absolute;left:-20px;top:-2px;fill:#b7b7b7}.dialog.update-occm-uris-dialog .modal .dialog-content .isDefault .mark-default{color:#003eae}.dialog.update-occm-uris-dialog .modal .dialog-content .isDefault .mark-default svg{fill:#003eae}.dialog.update-occm-uris-dialog .modal .dialog-content label{font-size:14px;color:#636363}.dialog.update-occm-uris-dialog .modal .dialog-content input{outline:none;height:40px;width:450px;border-radius:2px;border:1px solid #d7d7d7;padding-left:20px}.dialog.update-occm-uris-dialog .modal .dialog-content input:focus{border:1px solid #003eae}.dialog.update-occm-uris-dialog .modal .dialog-content input:disabled{background-color:#e9e9e9;border-color:#e9e9e9}.dialog.update-occm-uris-dialog .modal .dialog-content .remove-uri{border:none;background-color:transparent;outline:none;padding:0;margin:0 0 0 30px}.dialog.update-occm-uris-dialog .modal .dialog-content .remove-uri .isvg{width:23px;height:23px;display:inline-block;position:relative;top:8px}.dialog.update-occm-uris-dialog .modal .dialog-content .add-new-uri{border:none;background-color:transparent;outline:none;color:#636363;font-size:13px;height:25px;line-height:25px;padding-left:28px;position:relative;margin-bottom:43.5px;margin-top:14px}.dialog.update-occm-uris-dialog .modal .dialog-content .add-new-uri svg{fill:#003eae;position:absolute;left:0}.dialog.update-occm-uris-dialog .modal .dialog-buttons{border-top:1px solid #d7d7d7;padding-top:18px}.dialog.update-occm-uris-dialog .modal .dialog-buttons button{margin-left:11px}", "", {"version":3,"sources":["/buildagent/work/b80dd0081a060cbb/ui/src/components/launch-pad/UpdateOccmUris.css"],"names":[],"mappings":"AAAA,uCACE,YAAa,AACb,aAAc,AACd,sBAAuB,AACvB,uBAAwB,AACxB,kBAAmB,AACnB,kBAAoB,CAAE,AACtB,mDACE,kBAAmB,AACnB,eAAgB,AAChB,eAAoB,CAAE,AACxB,0CACE,eAAgB,AAChB,gBAAoB,AACpB,cAAe,AACf,kBAAqB,AACrB,+BAAiC,CAAE,AACrC,uDACE,gBAAkB,CAAE,AACpB,iFACE,kBAAoB,CAAE,AACxB,qEACE,YAAa,AACb,aAAc,AACd,6BAA8B,AAC9B,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,YAAa,AACb,kBAAmB,AACnB,iBAAmB,CAAE,AACrB,yEACE,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,YAAc,CAAE,AACpB,gFACE,aAAe,CAAE,AACjB,oFACE,YAAc,CAAE,AACpB,6DACE,eAAgB,AAChB,aAAe,CAAE,AACnB,6DACE,aAAc,AACd,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,iBAAmB,CAAE,AACrB,mEACE,wBAA0B,CAAE,AAC9B,sEACE,yBAA0B,AAC1B,oBAAsB,CAAE,AAC5B,mEACE,YAAa,AACb,6BAA8B,AAC9B,aAAc,AACd,UAAW,AACX,iBAAmB,CAAE,AACrB,yEACE,WAAY,AACZ,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,OAAS,CAAE,AACf,oEACE,YAAa,AACb,6BAA8B,AAC9B,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,eAAiB,CAAE,AACnB,wEACE,aAAc,AACd,kBAAmB,AACnB,MAAQ,CAAE,AAChB,uDACE,6BAA8B,AAC9B,gBAAkB,CAAE,AACpB,8DACE,gBAAkB,CAAE","file":"UpdateOccmUris.css","sourcesContent":[".dialog.update-occm-uris-dialog .modal {\n  width: 600px;\n  height: 440px;\n  top: calc(50% - 220px);\n  left: calc(50% - 300px);\n  padding-left: 40px;\n  padding-right: 40px; }\n  .dialog.update-occm-uris-dialog .modal .error-text {\n    position: absolute;\n    font-size: 13px;\n    font-weight: normal; }\n  .dialog.update-occm-uris-dialog .modal h3 {\n    font-size: 18px;\n    font-weight: normal;\n    color: #636363;\n    margin: 37px 0 4px 0;\n    border-bottom: 1px solid #d7d7d7; }\n  .dialog.update-occm-uris-dialog .modal .dialog-content {\n    padding-top: 25px; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content .uri-row:not(:last-child) {\n      margin-bottom: 36px; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content .mark-default {\n      border: none;\n      outline: none;\n      background-color: transparent;\n      color: #b7b7b7;\n      font-size: 13px;\n      font-weight: bolder;\n      float: right;\n      margin-right: 80px;\n      position: relative; }\n      .dialog.update-occm-uris-dialog .modal .dialog-content .mark-default svg {\n        position: absolute;\n        left: -20px;\n        top: -2px;\n        fill: #b7b7b7; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content .isDefault .mark-default {\n      color: #003eae; }\n      .dialog.update-occm-uris-dialog .modal .dialog-content .isDefault .mark-default svg {\n        fill: #003eae; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content label {\n      font-size: 14px;\n      color: #636363; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content input {\n      outline: none;\n      height: 40px;\n      width: 450px;\n      border-radius: 2px;\n      border: solid 1px #d7d7d7;\n      padding-left: 20px; }\n      .dialog.update-occm-uris-dialog .modal .dialog-content input:focus {\n        border: solid 1px #003eae; }\n      .dialog.update-occm-uris-dialog .modal .dialog-content input:disabled {\n        background-color: #e9e9e9;\n        border-color: #e9e9e9; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content .remove-uri {\n      border: none;\n      background-color: transparent;\n      outline: none;\n      padding: 0;\n      margin: 0 0 0 30px; }\n      .dialog.update-occm-uris-dialog .modal .dialog-content .remove-uri .isvg {\n        width: 23px;\n        height: 23px;\n        display: inline-block;\n        position: relative;\n        top: 8px; }\n    .dialog.update-occm-uris-dialog .modal .dialog-content .add-new-uri {\n      border: none;\n      background-color: transparent;\n      outline: none;\n      color: #636363;\n      font-size: 13px;\n      height: 25px;\n      line-height: 25px;\n      padding-left: 28px;\n      position: relative;\n      margin-bottom: 43.5px;\n      margin-top: 14px; }\n      .dialog.update-occm-uris-dialog .modal .dialog-content .add-new-uri svg {\n        fill: #003eae;\n        position: absolute;\n        left: 0; }\n  .dialog.update-occm-uris-dialog .modal .dialog-buttons {\n    border-top: 1px solid #d7d7d7;\n    padding-top: 18px; }\n    .dialog.update-occm-uris-dialog .modal .dialog-buttons button {\n      margin-left: 11px; }\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1078);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(806)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./CloudManagersView.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./CloudManagersView.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(806)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./RemoveOccmDialog.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./RemoveOccmDialog.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1080);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(806)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./UpdateOccmUris.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./UpdateOccmUris.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow-circle-icon.f57d8159.svg";

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(21);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(14);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIZE = 50;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1);
  // https://gist.github.com/gre/1650294
  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    svg: {},
    svgIndeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
    },
    circle: {
      stroke: 'currentColor',
      strokeLinecap: 'round'
    },
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-120px'
      }
    }
  };
};

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
function CircularProgress(props) {
  var _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      max = props.max,
      min = props.min,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'max', 'min', 'size', 'style', 'thickness', 'value', 'variant']);


  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var relVal = getRelativeValue(value, min, max) * 100;
    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(relVal);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = ((100 - relVal) / 100 * circumference).toFixed(3) + 'px';
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = (easeIn((100 - relVal) / 100) * circumference).toFixed(3) + 'px';
      rootStyle.transform = 'rotate(' + (easeOut(relVal / 70) * 270).toFixed(3) + 'deg)';
    }
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), className),
      style: (0, _extends3.default)({ width: size, height: size }, rootStyle, style),
      role: 'progressbar'
    }, rootProps, other),
    _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(classes.svg, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.svgIndeterminate, variant === 'indeterminate'), (0, _defineProperty3.default)(_classNames2, classes.svgStatic, variant === 'static'), _classNames2)),
        viewBox: '0 0 ' + SIZE + ' ' + SIZE
      },
      _react2.default.createElement('circle', {
        className: (0, _classnames2.default)(classes.circle, (0, _defineProperty3.default)({}, classes.circleIndeterminate, variant === 'indeterminate')),
        style: circleStyle,
        cx: SIZE / 2,
        cy: SIZE / 2,
        r: SIZE / 2 - 5,
        fill: 'none',
        strokeWidth: thickness
      })
    )
  );
}

CircularProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary', 'inherit']),
  /**
   * The max value of progress in determinate variant.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress in determinate variant.
   */
  min: _propTypes2.default.number,
  /**
   * The size of the circle.
   */
  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * The thickness of the circle.
   */
  thickness: _propTypes2.default.number,
  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The variant of progress indicator. Use indeterminate
   * when there is no progress value.
   */
  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'static'])
} : {};

CircularProgress.defaultProps = {
  color: 'primary',
  max: 100,
  min: 0,
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCircularProgress', flip: false })(CircularProgress);

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(21);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(7);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(3);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(14);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSITION_DURATION = 4; // 400ms

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },
    buffer: {
      backgroundColor: 'transparent'
    },
    query: {
      transform: 'rotate(180deg)'
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },
    dashedColorPrimary: {
      backgroundImage: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    dashedColorSecondary: {
      backgroundImage: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6) + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    bar1Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    bar2Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },
    bar1Determinate: {
      willChange: 'transform',
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    bar1Buffer: {
      zIndex: 1,
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    bar2Buffer: {
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'value', 'valueBuffer', 'variant']);


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty3.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames2.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames2.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty3.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty3.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty3.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames2.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty3.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = { bar1: {}, bar2: {} };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = 'scaleX(' + value / 100 + ')';
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = 'scaleX(' + (valueBuffer || 0) / 100 + ')';
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className, role: 'progressbar' }, rootProps, other),
    variant === 'buffer' ? _react2.default.createElement('div', { className: dashedClass }) : null,
    _react2.default.createElement('div', { className: bar1ClassName, style: inlineStyles.bar1 }),
    variant === 'determinate' ? null : _react2.default.createElement('div', { className: bar2ClassName, style: inlineStyles.bar2 })
  );
}

LinearProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes2.default.number,
  /**
   * The variant of progress indicator. Use indeterminate or query
   * when there is no progress value.
   */
  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};

LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiLinearProgress' })(LinearProgress);

/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CircularProgress = __webpack_require__(1108);

Object.defineProperty(exports, 'CircularProgress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CircularProgress).default;
  }
});

var _LinearProgress = __webpack_require__(1109);

Object.defineProperty(exports, 'LinearProgress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LinearProgress).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RemoveOccmDialog_css__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RemoveOccmDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RemoveOccmDialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_netapp_services_ontap_cloud_svg__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_netapp_services_ontap_cloud_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_netapp_services_ontap_cloud_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_inlinesvg__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_inlinesvg__);









var DumbRemoveOccmDialog = function DumbRemoveOccmDialog(_ref) {
    var closeDialog = _ref.closeDialog,
        removeOccmState = _ref.removeOccmState,
        occm = _ref.occm,
        removeOccm = _ref.removeOccm;

    var wrappedRemove = function wrappedRemove() {
        removeOccm(occm.occm).then(function () {
            closeDialog();
        });
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Remove Cloud Manager Listing'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dialog-content", { error: removeOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* STATUS_ERROR */] }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Are you sure you want to remove this Cloud Manager listing?'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'The Cloud Manager will be removed from your list of Cloud Managers, but the instance itself will remain.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'occm-row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'logo' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_inlinesvg___default.a, { src: __WEBPACK_IMPORTED_MODULE_6_images_netapp_services_ontap_cloud_svg___default.a })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'info', style: { width: occm.primaryCallbackUri ? "180px" : "385px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'title' },
                        'Name:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'text text-ellipsis' },
                        occm.occmName
                    )
                ),
                occm.primaryCallbackUri && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'info', style: { width: "180px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'title' },
                        'Address:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'text text-ellipsis' },
                        occm.primaryCallbackUri
                    )
                )
            )
        ),
        removeOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* STATUS_ERROR */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'error-text' },
            'Failed to remove: ',
            removeOccmState.data.message
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dialog-buttons' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'cancel medium right', onClick: closeDialog, disabled: removeOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* STATUS_PENDING */] },
                'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'secondary medium right', onClick: wrappedRemove, disabled: removeOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* STATUS_PENDING */] },
                removeOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* STATUS_PENDING */] ? "Removing..." : "Remove"
            )
        )
    );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        removeOccm: function removeOccm(occmId) {
            var payload = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/occm/deassociate-self", {
                occmId: occmId
            });

            dispatch({
                type: "REMOVE-OCCM",
                payload: payload
            });

            return payload;
        }
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        removeOccmState: state.services.removeOccmState || {}
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DumbRemoveOccmDialog));

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UpdateOccmUris_css__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UpdateOccmUris_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UpdateOccmUris_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_icons_Icons__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v4__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_icons_x_circle_icon_svg__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_icons_x_circle_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_icons_x_circle_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_inlinesvg__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_svg_icons_Icons__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Tooltip__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_Tooltip__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var DumbUpdateIpsDialog = function (_Component) {
    _inherits(DumbUpdateIpsDialog, _Component);

    function DumbUpdateIpsDialog(props) {
        _classCallCheck(this, DumbUpdateIpsDialog);

        var _this = _possibleConstructorReturn(this, (DumbUpdateIpsDialog.__proto__ || Object.getPrototypeOf(DumbUpdateIpsDialog)).call(this, props));

        var occm = props.occm;

        var manualOverrideUris = occm.manualOverrideUris || [];
        var automaticCallbackUris = occm.automaticCallbackUris || [];
        props.clearUpdateOccmState();
        var uris = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep([{ value: automaticCallbackUris[0] }].concat(manualOverrideUris));
        if (!manualOverrideUris.find(function (el) {
            return el.isDefault;
        })) {
            uris[0].isDefault = true;
        }

        uris.forEach(function (uri) {
            uri.uuid = __WEBPACK_IMPORTED_MODULE_8_uuid_v4___default()();
        });

        _this.state = { uris: uris };
        return _this;
    }

    _createClass(DumbUpdateIpsDialog, [{
        key: 'addNewUri',
        value: function addNewUri() {
            this.props.clearUpdateOccmState();
            this.setState({ uris: this.state.uris.concat([{ uuid: __WEBPACK_IMPORTED_MODULE_8_uuid_v4___default()(), value: "", isDefault: false }]) });
        }
    }, {
        key: 'setUriAsDefault',
        value: function setUriAsDefault(uri) {
            if (!uri.value) return;
            this.props.clearUpdateOccmState();
            this.state.uris.forEach(function (el) {
                el.isDefault = false;
            });

            uri.isDefault = true;
            this.setState({ uris: this.state.uris });
        }
    }, {
        key: 'handleUriChange',
        value: function handleUriChange(uri, event) {
            this.props.clearUpdateOccmState();
            uri.value = event.target.value;
            this.setState({ uris: this.state.uris });
        }
    }, {
        key: 'removeUri',
        value: function removeUri(uri) {
            this.props.clearUpdateOccmState();
            if (uri.isDefault) {
                // eslint-disable-next-line
                this.state.uris[0].isDefault = true;
            }
            this.setState({ uris: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.without(this.state.uris, uri) });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                closeDialog = _props.closeDialog,
                editOccmState = _props.editOccmState,
                occm = _props.occm,
                updateOccmUris = _props.updateOccmUris;


            var wrappedEdit = function wrappedEdit() {
                _this2.setState({ uris: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(_this2.state.uris, function (el) {
                        return el.value;
                    }) }, function () {
                    updateOccmUris(occm.occm, __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.drop(_this2.state.uris, 1)).then(function () {
                        closeDialog();
                    });
                });
            };
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    'Update \'',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'text-ellipsis', style: { maxWidth: 368, display: "inline-block", position: "relative", top: 5 } },
                        occm.occmName
                    ),
                    '\' URIs'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dialog-content", { error: editOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* STATUS_ERROR */] }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_react_custom_scrollbars__["Scrollbars"],
                        {
                            thumbSize: 126,
                            style: { width: "calc(100% + 15px)", height: 186 },
                            renderThumbVertical: function renderThumbVertical(props) {
                                var style = props.style;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', Object.assign({}, props, { style: Object.assign({}, style, { cursor: "pointer", width: "5px", borderRadius: "5px", backgroundColor: "#e9e9e9" }) }));
                            } },
                        this.state.uris.map(function (uri, index) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: uri.uuid, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("uri-row", { isDefault: uri.isDefault }) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { marginBottom: 3 } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'label',
                                        null,
                                        index === 0 ? "Cloud Manager Address (Automatically Set)" : 'URI ' + (index + 1)
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'button',
                                        { className: 'mark-default', onClick: function onClick() {
                                                return _this2.setUriAsDefault(uri);
                                            } },
                                        uri.isDefault ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icons_Icons__["c" /* StarIcon */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icons_Icons__["d" /* StarBorderIcon */], null),
                                        'Mark as default'
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { disabled: index === 0 ? "disabled" : false, autoFocus: true, value: uri.value, onChange: function onChange(event) {
                                            return _this2.handleUriChange(uri, event);
                                        } }),
                                    index !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'button',
                                        { className: 'remove-uri', onClick: function onClick() {
                                                return _this2.removeUri(uri);
                                            } },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_inlinesvg___default.a, { src: __WEBPACK_IMPORTED_MODULE_9_images_icons_x_circle_icon_svg___default.a })
                                    )
                                ),
                                editOccmState.hasInvalidUris && editOccmState.invalidUris.includes(index - 1) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'error-text' },
                                    'Invalid URI'
                                )
                            );
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'add-new-uri', onClick: function onClick() {
                                return _this2.addNewUri();
                            } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icons_Icons__["e" /* AddCircleIcon */], null),
                        'Add New URI'
                    )
                ),
                editOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* STATUS_ERROR */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { position: "absolute", fontSize: 13, fontWeight: "normal" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13_material_ui_Tooltip___default.a,
                        { id: 'tooltip-icon', style: { cursor: "help" }, title: editOccmState.hasInvalidUris ? "Provided URIs are invalid." : editOccmState.data.message, placement: 'top', classes: { root: "launching-text", tooltip: "hanging-tooltip" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_svg_icons_Icons__["f" /* InfoIcon */], { style: { position: "relative", top: "8px", marginRight: "6px", color: "#ca3658" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { style: { color: "#ca3658" } },
                                'Failed to edit URIs'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dialog-buttons' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'cancel medium right', onClick: closeDialog, disabled: editOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* STATUS_PENDING */] },
                        'Cancel'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'secondary medium right', onClick: wrappedEdit, disabled: editOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* STATUS_PENDING */] },
                        editOccmState.status === __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* STATUS_PENDING */] ? "Saving..." : "Save"
                    )
                )
            );
        }
    }]);

    return DumbUpdateIpsDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateOccmUris: function updateOccmUris(occmId, uris) {
            var payload = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/occm/manual-update-uris", {
                occmId: occmId,
                redirectUris: uris
            });

            dispatch({
                type: "UPDATE-OCCM-URIS",
                payload: payload
            });

            return payload;
        },
        clearUpdateOccmState: function clearUpdateOccmState() {
            dispatch({
                type: "CLEAR-UPDATE-OCCM-URIS-STATE"
            });
        }
    };
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        editOccmState: state.services.editOccmState || {}
    };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DumbUpdateIpsDialog));

/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudManagersView_css__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudManagersView_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CloudManagersView_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_inlinesvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_icons_x_circle_icon_svg__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_icons_x_circle_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_icons_x_circle_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_icons_edit_pencil_icon_svg__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_icons_edit_pencil_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_icons_edit_pencil_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_icons_arrow_circle_icon_svg__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_icons_arrow_circle_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_icons_arrow_circle_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_Dialog__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Progress__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_svg_icons_Icons__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Tooltip__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RemoveOccmDialog__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UpdateOccmIps__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_netapp_services_ontap_cloud_svg__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_netapp_services_ontap_cloud_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_images_netapp_services_ontap_cloud_svg__);


















var isOlderThanThirtyMinutes = function isOlderThanThirtyMinutes(date) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()().subtract(30, 'minutes').valueOf() > date;
};

var serviceTracker = function serviceTracker(_ref) {
    var action = _ref.action;
    return function (service) {
        return window.ga('send', {
            hitType: 'event',
            eventCategory: 'LaunchPad',
            eventAction: action,
            eventLabel: service
        });
    };
};

var track = serviceTracker({ action: "ClickService" });
var trackIntent = serviceTracker({ action: "IntentService" });

var CloudManagersView = function CloudManagersView(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cloud-managers-view' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'component-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'component-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    { className: 'left' },
                    'Cloud Manager Systems'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: window.__services.occmSetupService, className: 'button large occm-blue right', onContextMenu: function onContextMenu() {
                            trackIntent("ontap-cloud");
                        }, onClick: function onClick() {
                            track("ontap-cloud");
                        } },
                    'Create a New Cloud Manager'
                )
            ),
            props.occms.status === __WEBPACK_IMPORTED_MODULE_13__actions__["a" /* STATUS_SUCCESS */] && props.occms.data.occms.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'component-contents' },
                props.occms.data.occms.map(function (occm) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { key: occm.occm, className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("occm-row", occm.status, { solitary: props.occms.data.occms.length === 1 }) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { href: occm.primaryCallbackUri, className: 'occm-info', onContextMenu: function onContextMenu() {
                                    trackIntent("cloud-manager");
                                }, onClick: function onClick() {
                                    track("cloud-manager");
                                } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'logo' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg___default.a, { src: __WEBPACK_IMPORTED_MODULE_16_images_netapp_services_ontap_cloud_svg___default.a, className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()({ grey: occm.status !== "ready" }) })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'info' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'title text-ellipsis' },
                                    'Name:'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'text text-ellipsis' },
                                    occm.occmName
                                )
                            ),
                            occm.status === "ready" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'info', style: { marginLeft: "20px", marginRight: "5px" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'title text-ellipsis' },
                                    'Address:'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'text text-ellipsis' },
                                    occm.primaryCallbackUri
                                )
                            ),
                            occm.status === "ready" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'goto' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg___default.a, { src: __WEBPACK_IMPORTED_MODULE_5_images_icons_arrow_circle_icon_svg___default.a, style: { position: "relative", top: 7 } }),
                                'Go to Cloud Manager'
                            ),
                            occm.status === "initializing" && (isOlderThanThirtyMinutes(occm.createDate) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11_material_ui_Tooltip___default.a,
                                { id: 'tooltip-icon', style: { cursor: "help" }, title: 'There may be a problem deploying this Cloud Manager system. Go to your cloud provider\u2019s console to find the IP address for the system and then log in to complete the setup process. If you need help, contact us by clicking the chat icon in the lower right of your web browser.', placement: 'bottom', classes: { root: "launching-text", tooltip: "hanging-tooltip" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_svg_icons_Icons__["b" /* WarningIcon */], { style: { position: "relative", top: "8px", color: "#ffa100" } }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'span',
                                        { style: { color: "#ffa100" } },
                                        'Launch is hanging...'
                                    )
                                )
                            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'launching-text' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Progress__["CircularProgress"], { style: { position: "relative", top: "3px" }, size: 20, thickness: 1.5, color: '#898989' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    null,
                                    'Launching Cloud Manager'
                                )
                            )),
                            occm.status === "failed" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'failed-text' },
                                'Cloud Manager failed to launch'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'occm-menu' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'dots' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'd1' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'd2' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'd3' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'menu-children' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'button',
                                    { disabled: occm.status !== "ready", className: 'menu-child', onClick: function onClick(el) {
                                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__dialog_Dialog__["b" /* openDialog */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UpdateOccmIps__["a" /* default */], { occm: occm, className: 'update-occm-uris-dialog' }), el.target);
                                        } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg___default.a, { src: __WEBPACK_IMPORTED_MODULE_4_images_icons_edit_pencil_icon_svg___default.a, style: { width: 13.5, height: 13.5, top: 2 } }),
                                    ' Edit URIs'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'button',
                                    { className: 'menu-child', onClick: function onClick(el) {
                                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__dialog_Dialog__["b" /* openDialog */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RemoveOccmDialog__["a" /* default */], { occm: occm, className: 'remove-occm-dialog' }), el.target);
                                        } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg___default.a, { src: __WEBPACK_IMPORTED_MODULE_3_images_icons_x_circle_icon_svg___default.a, style: { width: 15, height: 15, top: 3 } }),
                                    ' Remove Listing'
                                )
                            )
                        )
                    );
                })
            )
        )
    );
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        occms: state.services.occms
    };
};

/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps, {})(CloudManagersView));

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

var prefix = __webpack_require__(841)
var toCamelCase = __webpack_require__(992)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(829)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),

/***/ 829:
/***/ (function(module, exports) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(840)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(843);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(819);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(851);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(850);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(852);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(849);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(848);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(846);

var _defaultRenderElements = __webpack_require__(844);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__(845);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(819);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(994)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),

/***/ 993:
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(993)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ })

});


// WEBPACK FOOTER //
// static/js/2.92d06b0a.chunk.js